import { useTheme } from "next-themes";
import { Button } from "@/shared/components/ui/button";
import { Moon, Sun } from "lucide-react";
import { useEffect, useState } from "react";

export function ThemeToggle() {
  const { setTheme, resolvedTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  return (
    <Button
      variant="icon"
      size="icon"
      onClick={() => setTheme(resolvedTheme === "dark" ? "light" : "dark")}
      aria-label="Alternar tema"
    >
      {resolvedTheme === "dark" ? (
        <Sun size={100} className="text-black dark:text-white" />
      ) : (
        <Moon size={100} className="text-black dark:text-white" />
      )}
    </Button>
  );
}
